import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressBookingsPolicySnapshotsV1BookingPolicySnapshotsUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/booking-policy-snapshots',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/booking-policy-snapshots',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/_api/booking-policy-snapshots',
        destPath: '',
      },
      {
        srcPath: '/booking-policy-snapshots',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_bookings_booking-policy-snapshots';

/** Retrieves a list of booking policy snapshots by [booking IDs](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/about-the-bookings-apis). */
export function listPolicySnapshotsByBookingIds(
  payload: object
): RequestOptionsFactory<any> {
  function __listPolicySnapshotsByBookingIds({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.policy_snapshots.v1.booking_policy_snapshot',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.bookings.policy.snapshots.v1.BookingPolicySnapshots.ListPolicySnapshotsByBookingIds',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsPolicySnapshotsV1BookingPolicySnapshotsUrl(
        { protoPath: '/v1/policy-snapshots', data: payload, host }
      ),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'bookingPolicySnapshots.createdDate' },
              { path: 'bookingPolicySnapshots.policy.createdDate' },
              { path: 'bookingPolicySnapshots.policy.updatedDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listPolicySnapshotsByBookingIds;
}
